import { Building, Home, Ban, Users, Truck } from "lucide-react";

export default function FeatureBadges() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 py-3">
      {/* 1. Renter friendly & apartment friendly */}
      <div className="flex flex-col items-center text-center p-3">
        <div className="w-16 h-16 flex items-center justify-center text-brand-orange-500 mb-3">
          <div className="relative">
            <Building className="w-10 h-10" />
            <Home className="w-6 h-6 absolute -bottom-1 -right-3 text-brand-orange-400" />
          </div>
        </div>
        <p className="text-xs sm:text-sm text-gray-300 font-medium leading-snug">
          Renter friendly<br />&amp; apartment friendly
        </p>
      </div>

      {/* 2. No panels on your roof */}
      <div className="flex flex-col items-center text-center p-3">
        <div className="w-16 h-16 flex items-center justify-center mb-3">
          <div className="relative flex items-center justify-center">
            <Home className="w-10 h-10 text-white" />
            <div className="absolute -bottom-1 -right-2 bg-[#0f1317] rounded-full p-0.5">
              <Ban className="w-5 h-5 text-red-500" />
            </div>
          </div>
        </div>
        <p className="text-xs sm:text-sm text-gray-300 font-medium leading-snug">
          No panels<br />on your roof
        </p>
      </div>

      {/* 3. For everyone over 18 */}
      <div className="flex flex-col items-center text-center p-3">
        <div className="w-16 h-16 flex items-center justify-center mb-3">
          <div className="relative flex items-center justify-center">
            <Users className="w-10 h-10 text-white" />
            <div className="absolute -top-1 -right-4 w-7 h-7 rounded-full border-2 border-brand-orange-500 bg-[#0f1317] flex items-center justify-center">
              <span className="text-[10px] font-bold text-white leading-none">18+</span>
            </div>
          </div>
        </div>
        <p className="text-xs sm:text-sm text-gray-300 font-medium leading-snug">
          For everyone<br />over 18
        </p>
      </div>

      {/* 4. Moves with you when you move */}
      <div className="flex flex-col items-center text-center p-3">
        <div className="w-16 h-16 flex items-center justify-center mb-3">
          <div className="relative flex items-center justify-center">
            <div className="flex flex-col gap-1 mr-1">
              <div className="w-4 h-0.5 bg-brand-orange-500 rounded-full" />
              <div className="w-3 h-0.5 bg-brand-orange-500 rounded-full" />
              <div className="w-4 h-0.5 bg-brand-orange-500 rounded-full" />
            </div>
            <Truck className="w-10 h-10 text-white" />
          </div>
        </div>
        <p className="text-xs sm:text-sm text-gray-300 font-medium leading-snug">
          Moves with you<br />when you move
        </p>
      </div>
    </div>
  );
}
